
import React, { useReducer } from "react";
import axios2 from 'services/axios2';

import {useParams} from "react-router-dom";
import {Link,hashHistory} from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import { NuDropdown } from "components/nubox/NuDropdown";

import ImageUpload from "components/nubox/ImageUpload";
import NuConfirm from "components/nubox/Box/NuConfirm";
import NuInput from 'components/nubox/NuInput';
import NuListRadio from 'components/nubox/NuListRadio';
import ImageUploadSingle from "components/nubox/ImageUploadSingle";

import { withRouterJim } from "router/withRouterJim";

//--- CONTEXT API -----------
import { useStore, useDispatch, StoreContext } from "store/StoreProvider";
import {types, storeReducer} from "store/StoreReducer"

import { NotificationContainer, NotificationManager } from 'react-notifications';
import {
  Table,
  Button,
  Container,
  Modal,
  ModalHeader,
  ModalBody,
  FormGroup,
  ModalFooter,
  ToastHeader,
} from "reactstrap";

const cbo=[
  {  value:'1', label: 'label1'},
]


const initialForm = {
  idd:0,
  ope:'n',
  
  id_est:'',
  nro_doc:'',
  ap_pat:'',
  ap_mat:'',
  nombres:'',
  tel:'',
  fecha_naci:'',
  dir:'',
  email:'',
  foto_path1:'',
  estado:1,     
};

//$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$
class MiPerfilE extends React.Component {
  state = {

    modalImagen: false,
    
    form: Object.assign({}, initialForm),
    data: [],/* lista  */
    estados:[ { value:0, label: "Inactivo",color:"#da4a43"  },
      { value:1, label: "Activo", color:"#008ffb" },
    ],
  };
  //---------------------------------
  componentDidMount() {
    //--limpiamos el array de prueba
    this.setState({data:[]});

    // Get the userId param from the URL.
    //let idd = this.props.params.idd;
    //let ope = this.props.params.ope;
    let idd = this.props.store.user.id_est
    let ope = 'e'
    console.log("idd-->" + idd)
    console.log("ope-->" + ope)

    this.setState({ form:{...this.state.form, idd: idd, ope:ope}})
    if(ope==='e' || ope==='x'){
      this.cargar_form(idd, ope)
    }
    
    //this.cargar_citas();
  }
  //----------------especial, actualiza valores del form -------------------------------
  handleChangeForm = (e) => {
    //requerimos la prop name='?' en cada control
    
    //--- esto lo hacemos porque en vez de utilizar valores true, false
    //--- tenemos que utilizar 1, 0
    if(e.target.type==="checkbox"){

      let res = e.target.checked? 1:0;        
      this.setState({
        form:{
          ...this.state.form,
          [e.target.name]: res,
        }
      })
    }else{
      this.setState({
        form: {
          ...this.state.form,
          [e.target.name]: e.target.value,
        },
      });
    }
  };
  //-----------------------------------------
  cargar_form = (idd, ope) => {      

    let param = { 
      idd: idd,
      ope:'f'
    }
    console.log(param);
    axios2.post( "mi_perfil_e_store", param)
    .then(res => {
      
        if( res.data!==''){ 
            //añadimos el id y ope
            this.setState({
              form: {  ...res.data, 
                idd: idd,  
                ope: ope,
              },
            });
            
        }else{
          toast.error("Registro no encontrado", {
            position: toast.POSITION.TOP_RIGHT
          });
        }

    }).catch(error => {
        alert("---- Existio un error ---");
        console.log(error);
    });
  };
   /************************************************ */
   okImage = (filename) =>{    
    this.setState({ form:{...this.state.form,foto_path1 : filename}}); 
  }
  cancelImage = () =>{
    //---ocultamos la ventana
    this.setState({ form:{...this.state.form, foto_path1: '' }}); 
  }
  // Toggle for Modal
  //-------------
  handleSubmit = event => {
    event.preventDefault();
    //this.cargar_form();
  }
  //-----------------------------------------------
  aceptar_click = async () => {
    console.log("aceptar_click");
    this.save();
    /*    this.refNuConfirm.current.show({
      message: 'Esta seguro de proceder?',
      title: 'Confirmación',
      icon: 'fa fa-question-circle',
      classHeader: 'bg-default1 ',
      classButton: 'btn btn-danger',
      accept: () => {
          this.save();
      },
      reject: () => {
          console.log('cancel');
      },
      acceptLabel: 'Aceptar',
      rejectLabel: 'Cancelar'
    })*/
  }
  //----------------------------
  save =() =>{    
      let param =  this.state.form;
      //param.id_rol= 1; //rol estudiante

      console.log(param);
      axios2.post("estudiante_store", param)
      .then(res => {
          if(res.data.exito === 1){ 
              toast.success(res.data.men);
              //--- tenemos que redireccionar
              //this.props.navigate('/EstudianteList');
          }else{
              toast.error(res.data.men);
          }
  
      }).catch(error => {
          alert("---- Existio un error ---");
          console.log(error);
          
      });
    
  }
  //------------------------------
  render() {
    return (
      <div>
        <div className="content">
        {
          //JSON.stringify(this.state.form)
        }
        {/* ---   --- */}
        <section className="content-header">
          <h3>
            {this.state.form.ope === 'n'
              ? "Nuevo "
              : "Perfil "
            }
            estudiante
          </h3>
        </section>

        <section className="content">

          <div className="card">

            <div className="card-body">
              {/*-----*/}

              <form className="row" >
                <div className="col-md-3">

                  <ImageUploadSingle
                        okImage={this.okImage}
                        cancelImage={this.cancelImage}
                        API_URL={ process.env.REACT_APP_API_URL }
                        imageURL={ process.env.REACT_APP_AFILES }
                        fileName={ this.state.form.foto_path1 }
                        withImage="150px"
                      />
                </div>
                {/*<!-- /.col -->*/}
                <div className="col-md-9">

                  

                  <div className='form-group row'>
                    <label htmlFor='id_est' className='col-lg-3 control-label'><b>Cod. Est.</b></label>
                    <div className='col-lg-9'>

                      <input
                        type='text'
                        name='id_est'
                        value={this.state.form.id_est}
                        onChange={this.handleChangeForm}
                        className='form-control'
                        disabled
                      />

                    </div>
                  </div>
                  <div className='form-group row'>
                    <label htmlFor='nro_doc' className='col-lg-3 control-label'><b>C.I.</b></label>
                    <div className='col-lg-9'>

                      <input
                        type='text'
                        name='nro_doc'
                        value={this.state.form.nro_doc}
                        onChange={this.handleChangeForm}
                        className='form-control'
                      />

                    </div>
                  </div>
                  <div className='form-group row'>
                    <label htmlFor='ap_pat' className='col-lg-3 control-label'><b>Paterno</b></label>
                    <div className='col-lg-9'>

                      <NuInput
                        className='form-control'
                        type='text'
                        name='ap_pat'
                        value={this.state.form.ap_pat}
                        onChange={this.handleChangeForm}
                        classOK=''
                        classError='is-invalid'
                        inputStyle={{textTransform: 'uppercase'}}
                        valtipo='string2'
                        
                      />
                    </div>
                  </div>
                  <div className='form-group row'>
                    <label htmlFor='ap_mat' className='col-lg-3 control-label'><b>Materno</b></label>
                    <div className='col-lg-9'>

                      <NuInput
                        className='form-control'
                        type='text'
                        name='ap_mat'
                        value={this.state.form.ap_mat}
                        onChange={this.handleChangeForm}
                        classOK=''
                        classError='is-invalid'
                        inputStyle={{textTransform: 'uppercase'}}
                        valtipo='string2'
                      />

                    </div>
                  </div>
                  <div className='form-group row'>
                    <label htmlFor='nombres' className='col-lg-3 control-label'><b>Nombres</b></label>
                    <div className='col-lg-9'>

                      <NuInput
                        className='form-control'
                        type='text'
                        name='nombres'
                        value={this.state.form.nombres}
                        onChange={this.handleChangeForm}
                        classOK=''
                        classError='is-invalid'
                        inputStyle={{textTransform: 'uppercase'}}
                        valtipo='string2'
                      />
                    </div>
                  </div>

                  <div className='top_title2'>
                    <h4 className=''>Datos</h4>
                  </div>

                  <div className='form-group row'>
                    <label htmlFor='tel' className='col-lg-3 control-label'><b>Fecha Nacimiento.</b></label>
                    <div className='col-lg-9'>

                      <NuInput
                        className='form-control'
                        type='date'
                        name='fecha_naci'
                        value={this.state.form.fecha_naci}
                        onChange={this.handleChangeForm}
                        classOK=''
                        classError='is-invalid'
                        valtipo='string2'
                      />

                    </div>
                  </div>

                  <div className='form-group row'>
                    <label htmlFor='tel' className='col-lg-3 control-label'><b>Telf.</b></label>
                    <div className='col-lg-9'>

                      <NuInput
                        className='form-control'
                        type='text'
                        name='tel'
                        value={this.state.form.tel}
                        onChange={this.handleChangeForm}
                        classOK=''
                        classError='is-invalid'
                        valtipo='string2'
                      />

                    </div>
                  </div>
                  
                  
                  <div className='form-group row'>
                    <label htmlFor='dir' className='col-lg-3 control-label'><b>Dirección</b></label>
                    <div className='col-lg-9'>

                      <NuInput
                        className='form-control'
                        type='text'
                        name='dir'
                        value={this.state.form.dir}
                        onChange={this.handleChangeForm}
                        classOK=''
                        classError='is-invalid'
                        valtipo='string2'
                      />

                    </div>
                  </div>

                  <div className='form-group row'>
                    <label htmlFor='email' className='col-lg-3 control-label'><b>Email</b></label>
                    <div className='col-lg-9'>

                      <input
                        type='text'
                        name='email'
                        value={this.state.form.email}
                        onChange={this.handleChangeForm}
                        className='form-control'
                        autoComplete='off'
                      />

                    </div>
                  </div>

                  <div className='form-group row'>
                    <label htmlFor='password' className='col-lg-3 control-label'><b>Estado</b></label>
                    <div className='col-lg-9'>

                      <NuListRadio
                        options={this.state.estados}
                        name="estado"
                        value={this.state.form.estado}
                        onChange={this.handleChangeForm}
                        isHorizontal={true}
                      />

                    </div>
                  </div>

                </div>
              </form>

            </div>

            <div className="card-footer">
              {/*
              <div className="form-group">
                <div className="text-center">
                  <Button onClick={this.aceptar_click} className="btn btn-info">
                    <i className="fa fa-floppy-o"></i>&nbsp;
                    Guardar
                  </Button>
                  &nbsp;
                  <Link to='/EstudianteList' className="btn btn-default">Volver</Link>
                </div>
              </div>
              */}
            </div>

          </div>

        </section>
        </div>
      

        <ToastContainer />
      </div>
    );
  }
}
  
//------------para que soporte la funcionalidad de parametros
export default withRouterJim(MiPerfilE);
